export default "__VITE_ASSET__WbwgFcUl__"